import { ITEM_CARD_SEQUENCE_LIST_VIEW, TIMELINE_VIEW } from "../constants/identifiers";

export default {
  portraitViewType: ITEM_CARD_SEQUENCE_LIST_VIEW,
  landscapeViewType: TIMELINE_VIEW
};
